<div soho-busyindicator
    [style.height]="'100%'"
    [blockUI]="true"
    [displayDelay]="20"
    [timeToComplete]="10000"
    [transparentOverlay]="true"
    [text]="' '"
>

  <soho-accordion
      [allowOnePane]="false"
      [hasPanels]="true"
      [hasSubheaderSeparators]="true"
      (selected)="onSelected($event)"
  >
    <ng-container *ngIf="filterListTemplateData && filterListTemplateData.length > 0; else ShowEmptyDataMessage">
      <ng-container *ngFor="let data of filterListTemplateData">

        <ng-container *ngIf="!data.groupItems; else GroupLabel;">
          <soho-accordion-header #AccordionHeader [attr.data-index]="data.index" (drop)="onDrop($event)" (dragstart)="onDragStart($event)" (dragleave)="onDragLeave($event)" (dragover)="onDragOver($event)">
            <lm-list-card [listSpec]="listSpec" [dataView]="data.item" [boldFirstRow]="false"></lm-list-card>
          </soho-accordion-header>
        </ng-container>

        <ng-template #GroupLabel>
          <soho-accordion-header>
            {{data.item}}
          </soho-accordion-header>
          <soho-accordion-pane>
            <ng-container *ngFor="let groupItem of data.groupItems">
              <soho-accordion-header #AccordionHeader [attr.data-index]="groupItem.index" (drop)="onDrop($event)" (dragstart)="onDragStart($event)" (dragleave)="onDragLeave($event)" (dragover)="onDragOver($event)">
                <lm-list-card [listSpec]="listSpec" [dataView]="groupItem.item" [boldFirstRow]="false"></lm-list-card>
              </soho-accordion-header>
            </ng-container>
          </soho-accordion-pane>
        </ng-template>

      </ng-container>
    </ng-container>
  </soho-accordion>

  <ng-template #ShowEmptyDataMessage>
    <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
  </ng-template>

</div>

<div #dialogPlaceholder id="lmFilterListDialogPlaceholder" class="lmDialogPlaceholder"></div>
